import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import T from '../../Utils/Locale';
import PropTypes from 'prop-types';
import PurchaseButton from './PurchaseButton';
import PurchaseType from '../Purchase/PurchaseType';
import PriceTag from './PriceTag';
/**
 * Figure whether the purchase button should display or not.
 *
 * If a document has been purchased, never show the purchase digital button.
 * Only show review purchase if digital was purchased, and always show advice if advice wasn't purchased.
 *
 * @returns {boolean}
 */
export const showPurchaseButton = (document, purchaseType) => {
    if (document && document.isPurchased) {
        switch (purchaseType) {
            case PurchaseType.DIGITAL:
                return false;
            case PurchaseType.REVIEW:
                return document.purchasedAsType === PurchaseType.DIGITAL;
            case PurchaseType.ADVICE:
                return document.purchasedAsType !== PurchaseType.ADVICE;
        }
    }
    return true;
};
function PriceBoxTypeContent({ purchaseType, productType, document = null }) {
    return (_jsxs(_Fragment, { children: [_jsx("p", Object.assign({ className: 'mb-2 font-normal xs:leading-normal leading-loose' }, { children: document && document.isPurchased
                    ? T(`dashboard.purchase_types.upgrade.${purchaseType}`)
                    : T(`dashboard.purchase_types.purchase.${purchaseType}`) })), _jsx("div", Object.assign({ className: 'actions mt-auto' }, { children: _jsx("div", Object.assign({ className: 'flex flex-row items-center' }, { children: showPurchaseButton(document, purchaseType) && (_jsxs(_Fragment, { children: [_jsx(PriceTag, { productType: productType, purchaseType: purchaseType, document: document }), _jsx(PurchaseButton, { productType: productType, purchaseType: purchaseType, legalDocument: document })] })) })) }))] }));
}
PriceBoxTypeContent.propTypes = {
    purchaseType: PropTypes.string.isRequired,
    productType: PropTypes.string.isRequired,
    document: PropTypes.shape({
        id: PropTypes.number.isRequired,
        isPurchased: PropTypes.bool.isRequired,
        purchasedAsType: PropTypes.string
    })
};
export default PriceBoxTypeContent;
